document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const muteButton = document.querySelector('.js-video-mute');
    const video = document.querySelector('.video-iframe');

    if (muteButton) {
      muteButton.addEventListener('click', () => {
        muteButton.classList.toggle('is-muted'), muteButton.classList.contains('is-muted') ? mute() : unmute();
      });
    }

    function mute() {
      if (video) {
        if (video.src.includes('youtube')) {
          let ytSrc = video.getAttribute('src');
          ytSrc = ytSrc.replace('mute=0', 'mute=1');
          video.setAttribute('src', ytSrc);
        } else if (video.src.includes('vimeo')) {
          let vimeoSrc = video.getAttribute('src');
          vimeoSrc = vimeoSrc.replace('muted=0', 'muted=1');
          video.setAttribute('src', vimeoSrc);
        }
      }
    }

    function unmute() {
      if (video.src.includes('youtube')) {
        let ytSrc = video.getAttribute('src');
        ytSrc = ytSrc.replace('mute=1', 'mute=0');
        video.setAttribute('src', ytSrc);
      } else if (video.src.includes('vimeo')) {
        let vimeoSrc = video.getAttribute('src');
        vimeoSrc = vimeoSrc.replace('muted=1', 'muted=0');
        video.setAttribute('src', vimeoSrc);
      }
    }
  }, 1000);
});
